
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import PersonsListView from "./persons-list.html";
import PersonsDuplicatesListView from "./persons_duplicates-list.html";
import PersonsEditView from "./persons-edit.html";
import PersonImportView from "./import/person-import.html";

angular.module("persons", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('persons', {
                url: "/persons",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('persons.list', {
                url: "/list/:person_type/:reset?group_id",
                controller: "PersonsListCtrl",
                template: PersonsListView,
                cache: false,
                data: { pageTitle: "Autoridades" },
                requiredPermission: ["PERSONS_READ"]
            })
            .state('persons.duplicates_list', {
                url: "/list/duplicates",
                controller: "PersonsDuplicatesListCtrl",
                template: PersonsDuplicatesListView,
                cache: false,
                data: { pageTitle: "Autoridades" },
                requiredPermission: ["PERSONS_READ"]
            })
            .state('persons.edit', {
                url: "/edit/:person_type/:id",
                controller: "PersonsEditCtrl",
                template: PersonsEditView,
                cache: false,
                data: { pageTitle: "Autoridades" },
                params: {
                    person_type: null,
                    id: null,
                    coming_from_duplicates: false,
                    personsIds: []
                },
                requiredPermission: ["PERSONS_READ"]
            })
            .state('persons.import', {
                url: "/import",
                controller: "PersonsImportCtrl",
                template: PersonImportView,
                cache: false,
                requiredPermission: ["PERSONS_READ"],
                params: {
                    people: null,
                    person_type: 'anonymous'
                }
            })
        ;
    }])
;